import React, { useState, useEffect, useRef } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./style.css";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { contactFromContactUsAPI } from "../../redux/slices/ContactFormApiSlice";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";
import ActionButton from "../ActionButton";
import { GoHighLevelAPI, SendEmailContactUsAPI } from "../../redux/slices/SendEmail";

import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

import ReCAPTCHA from "react-google-recaptcha";

const siteKey = "6LeypvQrAAAAAGBfUbMFmuJ9U9d_LEDLLnoGP1uB";

const ContactBanner = () => {
  const dispatch = useDispatch();

  const recaptchaRef = useRef(null);

  const [captchaToken, setCaptchaToken] = useState("");

  const [isLoading, setIsLoading] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const notify = () => toast("Your query submitted successfully!");

  const loading = useSelector((state) => state?.contactFormApiSlice?.loading);

  const [contactUsPageFormData, setContactUsPageFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
    company_name: "",
    country_name: "",
    about_project: "",
    nda: null,
    services: [],
    captchaToken: captchaToken,
  });

  const [prevPage, setPrevPage] = useState(null);

  useEffect(() => {
    const prev = sessionStorage.getItem("prevPath");
    setPrevPage(prev);
    console.log("Previous Page:", prev);
  }, []);

  // const isFormComplete = () => {
  //   return (
  //     contactUsPageFormData.name &&
  //     contactUsPageFormData.phone_number &&
  //     contactUsPageFormData.email &&
  //     contactUsPageFormData.company_name &&
  //     contactUsPageFormData.country_name &&
  //     contactUsPageFormData.about_project &&
  //     contactUsPageFormData.nda &&
  //     contactUsPageFormData.services.length > 0
  //   );
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setContactUsPageFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  const [errors, setErrors] = useState({});

  const validatePhone = (phone) => {
    const digits = phone.replace(/\D/g, "");
    if (!phone) return "Phone number is required";
    if (digits.length < 8) return "Enter a complete valid phone number";
    return "";
  };

  const handleBlur = () => {
    const error = validatePhone(contactUsPageFormData.phone_number);
    if (error) {
      setErrors((prev) => ({ ...prev, phone_number: error }));
    } else {
      setErrors((prev) => {
        const copy = { ...prev };
        delete copy.phone_number;
        return copy;
      });
    }
  };

  const handlePhoneChange = (phone) => {
    setContactUsPageFormData((prev) => ({
      ...prev,
      phone_number: phone,
    }));

    // validate on change
    // const error = validatePhone(phone);
    // setErrors((prev) => ({
    //   ...prev,
    //   phone_number: error,
    // }));

    if (phone && phone.trim() !== "") {
      const error = validatePhone(phone);
      setErrors((prev) => ({
        ...prev,
        phone_number: error,
      }));
    } else {
      // If user clears the input, remove any existing error
      setErrors((prev) => {
        const copy = { ...prev };
        delete copy.phone_number;
        return copy;
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactUsPageFormData({
      ...contactUsPageFormData,
      [name]: value,
    });
    // Clear error when user starts typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setContactUsPageFormData((prevData) => ({
      ...prevData,
      [name]: checked ? "Yes" : "No",
    }));
  };

  // const handleServicesChange = (selected) => {
  //   const selectedValues = selected.map((option) => option.value);
  //   setContactUsPageFormData((prevData) => ({
  //     ...prevData,
  //     services: selectedValues,
  //   }));
  // };

  const handleServicesChange = (selected) => {
    const selectedValues = selected.map((option) => option.value);

    setContactUsPageFormData((prevData) => ({
      ...prevData,
      services: selectedValues,
    }));

    // ✅ Clear the services error when user selects or changes options
    setErrors((prev) => ({
      ...prev,
      services: "",
    }));
  };


  // GOOGLE SHEET INTEGRATION
  const scriptURL = process.env.REACT_APP_GSHEET_URL;
  const sheetName = "ContactUsPageData";

  // const state = {
  //   FirstName: contactUsPageFormData.name,
  //   LastName: contactUsPageFormData.phone_number,
  //   Email: contactUsPageFormData.email,
  //   CompanyName: contactUsPageFormData.company_name,
  //   AboutProject: contactUsPageFormData.about_project,
  //   NDA: contactUsPageFormData.nda,
  //   Services: JSON.stringify(contactUsPageFormData.services),
  //   SheetName: sheetName,
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   console.log("Submitted Form Data:", state);

  //   // const res = await dispatch(contactFromContactUsAPI(contactUsPageFormData));
  //   // if (res.type === "contactFromContactUsAPI/fulfilled") {
  //   //   toast.success(res?.payload?.message);
  //   // } else if (res.type === "contactFromContactUsAPI/rejected") {
  //   //   toast.success(res.payload.errors);
  //   // } else {
  //   //   toast.error("Sorry, something went wrong!");
  //   // }
  //   // return;

  //   setIsLoading(true);

  //   const urlEncodedData = new URLSearchParams(state).toString();

  //   try {
  //     await fetch(scriptURL, {
  //       method: 'POST',
  //       mode: 'no-cors',
  //       headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //       },
  //       body: urlEncodedData,
  //     });

  //     console.log('Successfully submitted to Google Sheet.');
  //     toast.success("Data Successfully submitted");
  //     setContactUsPageFormData({ name: '', email: '', message: '' }); // Reset form
  //   } catch (error) {
  //     toast.error('Submission failed:', error);
  //     alert('Something went wrong. Please try again.');
  //   } finally {
  //     // Always re-enable button whether success or fail
  //     setIsLoading(false);
  //   }
  // };

  // const validateForm = () => {
  //   let newErrors = {};

  //   if (!contactUsPageFormData.name) newErrors.name = "Name is required";
  //   if (!contactUsPageFormData.email)
  //     newErrors.email = "Email is required";
  //   else if (!/\S+@\S+\.\S+/.test(contactUsPageFormData.email))
  //     newErrors.email = "Invalid email format";
  //   if (contactUsPageFormData.phone_number === "")
  //     newErrors.phone_number = "Phone number is required";
  //   if (!contactUsPageFormData.company_name)
  //     newErrors.company_name = "Company name is required";
  //   if (!contactUsPageFormData.country_name)
  //     newErrors.country_name = "Country name is required";
  //   if (!contactUsPageFormData.nda)
  //     newErrors.nda = "Please select NDA option";
  //   if (!contactUsPageFormData.services.length)
  //     newErrors.services = "Select at least one service";

  //   setErrors(newErrors);

  //   return Object.keys(newErrors).length === 0;
  // };

  useEffect(() => {
    setContactUsPageFormData((prev) => ({
      ...prev,
      captchaToken: captchaToken,
    }));
  }, [captchaToken]);

  const validateForm = () => {
    let newErrors = {};

    // Name validation
    if (!contactUsPageFormData.name)
      newErrors.name = "Name is required";

    // Email validation
    if (!contactUsPageFormData.email)
      newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(contactUsPageFormData.email))
      newErrors.email = "Invalid email format";

    // Phone validation (required + must have digits beyond country code)
    const phone = contactUsPageFormData.phone_number?.replace(/\D/g, ""); // remove non-digits

    // if (!contactUsPageFormData.phone_number)
    //   newErrors.phone_number = "Phone number is required";
    // else if (phone.length < 8)
    //   newErrors.phone_number = "Please enter a valid phone number";

    const phoneError = validatePhone(contactUsPageFormData.phone_number);
    if (phoneError) newErrors.phone_number = phoneError;

    // Company name
    if (!contactUsPageFormData.company_name)
      newErrors.company_name = "Company name is required";

    // Country name
    if (!contactUsPageFormData.country_name)
      newErrors.country_name = "Country name is required";

    // NDA validation
    if (!contactUsPageFormData.nda)
      newErrors.nda = "Please select NDA option";

    // Services validation
    if (!contactUsPageFormData.services.length)
      newErrors.services = "Select at least one service";

    if (!contactUsPageFormData.about_project)
      newErrors.about_project = "About your project is required";

    if (!contactUsPageFormData.captchaToken)
      newErrors.captchaToken = "Please Check the Recaptcha first";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!isFormComplete()) {
    //   toast.error("Please fill all required fields.");
    //   return;
    // }

    // Run validation
    const isValid = validateForm();


    // If validation fails, stop submission
    if (!isValid) {
      toast.error("Please fix the highlighted errors before submitting.");
      return;
    }

    setIsLoading(true);

    // return

    // await fetch("https://solutions.bitsclan.us/api/contact", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({
    //     captchaToken, // from reCAPTCHA
    //   }),
    // });

    // if (!captchaToken) {
    //   alert("Please verify reCAPTCHA before submitting.");
    //   return;
    // }

    await fetch("https://solutions.bitsclan.us/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        captchaToken, // from reCAPTCHA
      }),
    });

    if (!captchaToken) {
      alert("Please verify reCAPTCHA before submitting.");
      return;
    }

    const state = {
      Name: contactUsPageFormData.name,
      Phone: contactUsPageFormData.phone_number,
      Email: contactUsPageFormData.email,
      CompanyName: contactUsPageFormData.company_name,
      CountryName: contactUsPageFormData.country_name,
      AboutProject: contactUsPageFormData.about_project,
      NDA: contactUsPageFormData.nda,
      Services: JSON.stringify(contactUsPageFormData.services),
      SheetName: sheetName,
    };

    const urlEncodedData = new URLSearchParams(state).toString();

    try {
      await fetch(scriptURL, {
        method: "POST",
        mode: "no-cors", // Google Apps Script requires this
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: urlEncodedData,
      });

      toast.success("Submission complete. Thank you.");

      // Reset form
      setContactUsPageFormData({
        name: "",
        phone_number: "",
        email: "",
        company_name: "",
        country_name: "",
        about_project: "",
        nda: null,
        services: [],
        captchaToken: ""
      });

      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }

      const res = dispatch(SendEmailContactUsAPI(contactUsPageFormData))

      // const highLevelApiObject = {
      //   firstName: contactUsPageFormData?.name,
      //   phone: contactUsPageFormData?.phone_number,
      //   email: contactUsPageFormData?.email,
      //   nda: contactUsPageFormData.nda,
      //   companyName: contactUsPageFormData?.company_name,
      //   country: contactUsPageFormData?.country_name,
      //   service: JSON.stringify(contactUsPageFormData?.services),
      //   additionalNotes: contactUsPageFormData.about_project,
      //   tags: ["Filled website form", "Contact Us", prevPage]
      // }

      const highLevelApiObject = {
        firstName: contactUsPageFormData?.name,
        phone: contactUsPageFormData?.phone_number,
        email: contactUsPageFormData?.email,
        companyName: contactUsPageFormData?.company_name,
        country: contactUsPageFormData?.country_name,
        tags: ["Filled website form", "Contact Us", prevPage],
        "customField": {
          "EeybBPncGzJ3d1YgfoSN": contactUsPageFormData.nda, // nda
          "lYSo5L5rInfJTWE5Gotk": JSON.stringify(contactUsPageFormData.services), // service
          "1U1sbPiPhcCOhyONNCDE": contactUsPageFormData.about_project // additional_info
        }
      };

      console.log(highLevelApiObject, "highLevelApiObject");

      const resHighLevelObjectApi = dispatch(GoHighLevelAPI(highLevelApiObject))
      console.log(resHighLevelObjectApi);

      // if (res.type === "SendEmailContactUsAPI/fulfilled") {
      //   toast.success(res?.payload?.message);
      // } else if (res.type === "SendEmailContactUsAPI/rejected") {
      //   toast.success(res.payload.errors);
      // } else {
      //   toast.error("Sorry, something went wrong!");
      // }
    } catch (error) {
      console.error("Submission failed:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // GOOGLE SHEET INTIGRATION

  useEffect(() => {
    return () => {
      // ✅ Cleanup when component unmounts
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
    };
  }, []);


  const { t } = useTranslation("contactSection");
  const heading = t("heading", { returnObjects: true });
  const skilledTalent = t("skilledTalent", { returnObjects: true });
  const swiftTurnaround = t("swiftTurnaround", { returnObjects: true });
  const costEffective = t("costEffective", { returnObjects: true });
  const innovationDriven = t("innovationDriven", { returnObjects: true });
  const contactEmails = t("contactEmails", { returnObjects: true });
  const helloEmails = t("helloEmails", { returnObjects: true });
  const contactFormData = t("contactUsFormStaticData", { returnObjects: true });
  const servicesArray = t("servicesArray", { returnObjects: true });

  return (
    <>
      <ToastContainer hideProgressBar={true} />

      <div className="contact-banner-bg-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="contact-us-main-heading" dangerouslySetInnerHTML={{
                __html: heading,
              }}></h1>
              {/* <h2 className="contact-us-sub-heading">Book a time with our sales team</h2> */}
            </div>
          </div>
        </div>
      </div>

      <div className="contact-banner-box">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-10 col-md-12">
              <div className="contact-side-form contact-banner-form contact-banner-side">
                <div className="container p-0">
                  <form
                    className="row contact-side-form-box"
                    onSubmit={handleSubmit}
                  >
                    <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper">
                        <label htmlFor="name">
                          {contactFormData?.firstName?.label}
                        </label>
                        <div>
                          <input
                            type="text"
                            className="contact-form-input w-100"
                            placeholder={contactFormData?.firstName?.placeholder}
                            id="name"
                            name="name"
                            value={contactUsPageFormData.name}
                            onChange={handleInputChange}
                          />
                          {errors.name && <p className="text-danger error-text mb-0 mt-1">{errors.name}</p>}
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper">
                        <label htmlFor="phone_number">
                          {contactFormData?.phone?.label}
                        </label>
                        <div>
                          <PhoneInput
                            defaultCountry="us"
                            value={contactUsPageFormData.phone_number}
                            onChange={(phone) =>
                              setContactUsPageFormData((prev) => ({
                                ...prev,
                                phone_number: phone,
                              }))
                            }
                            className="contact-form-input w-100"
                            inputProps={{
                              name: "phone_number",
                              id: "phone_number",
                              required: true,
                            }}
                          />
                          {errors.phone_number && <p className="text-danger error-text mb-0 mt-1">{errors.phone_number}</p>}
                        </div>
                      </div>
                    </div> */}

                    {/* Phone */}
                    {/* <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper">
                        <label htmlFor="phone_number">{contactFormData?.phone?.label}</label>

                        <div className="w-100">
                          <PhoneInput
                            // defaultCountry="us"
                            defaultCountry={undefined}
                            hideDropdown={false}
                            disableDialCodePrefill={true}
                            placeholder="Enter phone number"
                            value={contactUsPageFormData.phone_number || ""}
                            onChange={(phone) => {
                              // update state
                              setContactUsPageFormData((prev) => ({
                                ...prev,
                                phone_number: phone,
                              }));
                              if (phone) {
                                setErrors((prev) => {
                                  const copy = { ...prev };
                                  delete copy.phone_number;
                                  return copy;
                                });
                              }
                            }}
                            inputProps={{
                              name: "phone_number",
                              id: "phone_number",
                              onBlur: () => {
                                const phone = contactUsPageFormData.phone_number;
                                if (!phone) {
                                  setErrors((prev) => ({ ...prev, phone_number: "Phone number is required" }));
                                } else {
                                  const digits = String(phone).replace(/\D/g, "");
                                  if (digits.length < 7) {
                                    setErrors((prev) => ({ ...prev, phone_number: "Enter a valid phone number" }));
                                  } else {
                                    setErrors((prev) => {
                                      const copy = { ...prev };
                                      delete copy.phone_number;
                                      return copy;
                                    });
                                  }
                                }
                              },
                            }}
                            className={`contact-form-input w-100 ${errors.phone_number ? "is-invalid" : ""}`}
                          />

                          {errors.phone_number && (
                            <p className="text-danger error-text mb-0 mt-1">{errors.phone_number}</p>
                          )}
                        </div>
                      </div>
                    </div> */}

                    <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper">
                        <label htmlFor="phone_number">Phone Number</label>

                        <div className="w-100">
                          <PhoneInput
                            defaultCountry={undefined}
                            hideDropdown={false}
                            disableDialCodePrefill={true}
                            placeholder="Enter phone number"
                            value={contactUsPageFormData.phone_number || ""}
                            onChange={handlePhoneChange}
                            onBlur={handleBlur}
                            inputProps={{
                              name: "phone_number",
                              id: "phone_number",
                              placeholder: "Enter phone number",
                            }}
                            className={`contact-form-input w-100 ${errors.phone_number ? "is-invalid" : ""
                              }`}
                          />
                          {errors.phone_number && (
                            <p className="text-danger error-text mb-0 mt-1">
                              {errors.phone_number}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper mt-3">
                        <label htmlFor="email">
                          {contactFormData?.email?.label}
                        </label>
                        <div>
                          <input
                            type="email"
                            className="contact-form-input w-100"
                            placeholder={contactFormData?.email?.placeholder}
                            id="email"
                            name="email"
                            value={contactUsPageFormData.email}
                            onChange={handleInputChange}
                          />
                          {errors.email && <p className="text-danger error-text mb-0 mt-1">{errors.email}</p>}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper mt-3">
                        <label htmlFor="nda">
                          {contactFormData?.nda?.label}
                        </label>
                        <div>
                          <div className="d-flex gap-2">
                            <div className="form-check contact-us-radio-wrapper">
                              <input
                                className="form-check-input contact-us-radio"
                                type="radio"
                                name="nda"
                                value="Yes"
                                id="yes"
                                checked={contactUsPageFormData.nda === "Yes"}
                                onChange={handleInputChange}
                              />
                              <label htmlFor="yes">{contactFormData?.nda?.options?.[0]}</label>
                            </div>
                            <div className="form-check contact-us-radio-wrapper">
                              <input
                                className="form-check-input contact-us-radio"
                                type="radio"
                                name="nda"
                                value="No"
                                id="No"
                                checked={contactUsPageFormData.nda === "No"}
                                onChange={handleInputChange}
                              />
                              <label htmlFor="No">{contactFormData?.nda?.options?.[1]}</label>
                            </div>
                          </div>
                          {errors.nda && <p className="text-danger error-text mb-0 mt-1">{errors.nda}</p>}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper mt-3">
                        <label htmlFor="company_name">
                          {contactFormData?.companyName?.label}
                        </label>
                        <div>
                          <input
                            type="text"
                            className="contact-form-input w-100"
                            placeholder={contactFormData?.companyName?.placeholder}
                            id="company_name"
                            name="company_name"
                            value={contactUsPageFormData.company_name}
                            onChange={handleInputChange}
                          />
                          {errors.company_name && <p className="text-danger error-text mb-0 mt-1">{errors.company_name}</p>}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="contact-us-form-feild-wrapper mt-3">
                        <label htmlFor="country_name">
                          {contactFormData?.CountryName?.label}
                        </label>
                        <div>
                          <input
                            type="text"
                            className="contact-form-input w-100"
                            placeholder={contactFormData?.CountryName?.placeholder}
                            id="country_name"
                            name="country_name"
                            value={contactUsPageFormData.country_name}
                            onChange={handleInputChange}
                          />
                          {errors.country_name && <p className="text-danger error-text mb-0 mt-1">{errors.country_name}</p>}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="contact-us-form-feild-wrapper  mt-3">
                        <label>
                          {contactFormData?.services?.label}
                        </label>
                        <div>
                          <Select
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: "transparent",
                                border: "1.12px solid #E9E9E9 !important",
                                boxShadow: "none !important",
                                color: "#FFFFFF",
                                borderRadius: "8px",
                                fontSize: "16px",
                              }),
                              placeholder: (baseStyles, state) => ({
                                ...baseStyles,
                                fontSize: "16px",
                              }),
                              menu: (baseStyles, state) => ({
                                ...baseStyles,
                                color: "black",
                              }),
                            }}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary25: "#80b927",
                              },
                            })}
                            isMulti
                            value={servicesArray.filter((service) =>
                              contactUsPageFormData.services.includes(
                                service.value
                              )
                            )}
                            onChange={handleServicesChange}
                            options={servicesArray}
                            placeholder={contactFormData?.services?.placeholder}
                          />
                          {errors.services && <p className="text-danger error-text mb-0 mt-1">{errors.services}</p>}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="contact-us-form-feild-wrapper mt-3">
                        <label htmlFor="about_project">
                          {contactFormData?.aboutProject?.label}
                        </label>
                        <div>
                          <textarea
                            placeholder={contactFormData?.aboutProject?.placeholder}
                            id="about_project"
                            className="contact-form-input w-100"
                            name="about_project"
                            value={contactUsPageFormData.about_project}
                            onChange={handleInputChange}
                          />
                          {errors.about_project && <p className="text-danger error-text mb-0 mt-1">{errors.about_project}</p>}
                        </div>
                      </div>
                    </div>

                    <div className="col-12 justify-content-between align-items-center mt-4 d-flex contact-form-button">
                      {/* <button
                        type="submit"
                        disabled={loading || !isFormComplete()}
                        className="btn btn-primary"
                      >
                        {loading
                          ? contactFormData?.submitButton?.loadingText
                          : contactFormData?.submitButton?.buttonText}
                      </button> */}

                      <div>
                        <ReCAPTCHA
                          sitekey={siteKey}
                          ref={recaptchaRef}
                          onChange={(token) => setCaptchaToken(token)}
                        // onChange={(token) =>
                        //   setContactUsPageFormData((prev) => ({
                        //     ...prev,
                        //     captchaToken: token,
                        //   }))
                        // }
                        />
                        {errors.captchaToken && <p className="text-danger error-text mb-0 mt-1">{errors.captchaToken}</p>}
                      </div>

                      <ActionButton
                        type="submit"
                        text={isLoading ? 'Submitting...' : contactFormData?.submitButton?.buttonText}
                        disabled={isLoading}
                        // || !isFormComplete()
                        link={
                          "https://calendly.com/bitsclan-it/30min?month=2025-01"
                        }
                        className="mt-4"
                        hideIcon
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <p className="form-description-text-contact-us">By submitting this form, you agree to our Privacy Policy & consent to receive communications from Bitsclan Inc. regarding updates, offers, & other promotional content. You can unsubscribe at any time by clicking the link in the footer of our emails.</p>
            </div>
          </div>
        </div>
      </div>

      <section className="contact-section-boxes">
        <div className="container">
          <div className="row justify-content-center general-queries-box">
            <div className="col-12 col-md-6 col-lg-5 col-xl-5">
              <div className="contact-box d-flex align-items-start p-4">
                <div className="contact-box-icon me-3">
                  <i class="fa-solid fa-envelope"></i>
                </div>
                <div className="contact-box-content">
                  <h5 className="contact-box-title">General Inquiries</h5>
                  <p className="contact-box-text">
                    For general inquiries, support & non-sales questions, please email: &nbsp;
                    {helloEmails?.map((item, index) => (
                      <a href={item.href} key={`email-${index}`}>{item.text}</a>
                    ))}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-5 col-xl-5">
              <div className="contact-box d-flex align-items-start p-4">
                <div className="contact-box-icon me-3">
                  <i class="fa-solid fa-at"></i>
                </div>
                <div className="contact-box-content">
                  <h5 className="contact-box-title">Careers</h5>
                  <p className="contact-box-text">
                    For Bitsclan news, company info & media resources, please email
                    <a href="mailto:career@bitsclan.com"> career@bitsclan.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <Popup
        open={isPopupOpen}
        position="center center"
        closeOnDocumentClick={false}
      >
        <div
          className="position-relative"
          style={{ backgroundColor: "rgb(242 242 242)" }}
        >
          <button
            onClick={() => setIsPopupOpen(false)}
            className="cross-btn-close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <video width="100%" height="100%" autoPlay muted>
            <source src="/videos/thankyou-vedio.mp4" type="video/mp4" />
          </video>

          <div className="d-flex justify-content-center pb-5">
            <a
              href="https://calendly.com/bitsclan-it/30min?month=2025-01"
              target="_blank"
            >
              Let's Talk
            </a>

            <Button
              link={"https://calendly.com/bitsclan-it/30min?month=2025-01"}
              text="Let's Talk"
              newTab
              hideIcon
            />
          </div>
        </div>
      </Popup>
    </>
  );
};

export default ContactBanner;
